import { BorerShiftDocument } from '../BorerShift/queryBuilder';
import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import { ConfigBuilder, doNotAutoSync, pull, push, replicate } from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import {
  PanelDrawingDocument,
  panelDrawingPullQueryBuilder,
  panelDrawingPushQueryBuilder,
} from './queryBuilder';

export function panelDrawingsFamilyMember(
  configBuilder: ConfigBuilder,
  borerShift: FamilyMember<BorerShiftDocument>,
): FamilyMember<PanelDrawingDocument> {
  const syncConfig = configBuilder<PanelDrawingDocument>(RxdbCollectionNameV2.PANEL_DRAWINGS);
  doNotAutoSync(syncConfig);

  const pullConfig = pull(syncConfig, panelDrawingPullQueryBuilder);
  pullConfig.batchSize = 34; //https://nutrien.atlassian.net/browse/MDP-7729
  push(syncConfig, panelDrawingPushQueryBuilder);

  const replicationState = replicate(syncConfig);
  // Legacy sets syncInterval to LiveInterval.SECONDS_60
  return create(RxdbCollectionNameV2.PANEL_DRAWINGS, replicationState, [borerShift]);
}
